module.exports = __webpack_public_path__ + "static/004.bd5dc10f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/004.png
// module id = 469
// module chunks = 35783957827783